"use client";

import { UserPerceivedLoadTimingContext } from "@faire/web/common/performance/userPerceivedLoadTiming/UserPerceivedLoadTimingContext";
import React, { useCallback } from "react";

interface Props {
  children: React.ReactNode;
  pageLoadKey: string;
}

export const SDUIFlowLayoutItemWithUPLTRef = ({
  children,
  pageLoadKey,
}: Props) => {
  const UPLTRefCallback = React.useContext(
    UserPerceivedLoadTimingContext
  )?.refCallback;

  const ref = useCallback(
    (element: HTMLDivElement | null) => {
      UPLTRefCallback?.(element, {
        status: "loaded",
        pageLoadKey: pageLoadKey,
      });
    },
    [UPLTRefCallback, pageLoadKey]
  );
  return <div ref={ref}>{children}</div>;
};
